import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'system' | 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  effectiveTheme: 'light' | 'dark';
  setTheme: (t: Theme) => void;
  applyTheme: () => void;
}

function computeEffective(theme: Theme): 'light' | 'dark' {
  if (theme === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return theme;
}

export const useTheme = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'system',
      effectiveTheme: 'light',
      setTheme: (t) => {
        const eff = computeEffective(t);
        set({ theme: t, effectiveTheme: eff });
        document.documentElement.classList.toggle('dark', eff === 'dark');
      },
      applyTheme: () => {
        const { theme } = get();
        const eff = computeEffective(theme);
        set({ effectiveTheme: eff });
        document.documentElement.classList.toggle('dark', eff === 'dark');
      },
    }),
    { name: 'blagomail.theme' }
  )
);
